import { Button, Flex } from '@chakra-ui/react';
import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';
import { InteractiveMenu } from 'widgets/sdk/Toolbar/InteractiveMenu';

import { MAX_URL_LENGTH } from './QRCodeWidget.config';
import { QRCodeWidgetData } from './QRCodeWidget.types';

export const QRCodeWidgetToolbarMenu = () => {
  const { widgetId } = useWidget();

  return (
    <Flex mr='8px' gap='8px' align='center'>
      <URL />
      <BackgroundColor />
      <ForeGroundColor />
      <AltTextMenu widgetId={widgetId} />
      <ToolbarDivider />
      <InteractiveMenu />
    </Flex>
  );
};

const BackgroundColor = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'qrCodeToolbar' });
  const { backgroundColor, updateWidget } = useWidget<QRCodeWidgetData>();

  const onUpdateBackgroundColor = (color: string) => updateWidget({ backgroundColor: color });

  return (
    <ColorPicker
      color={backgroundColor}
      label={t('backgroundColor')}
      onChange={onUpdateBackgroundColor}
      showNoColorOption={false}
      showNoColorChecker
    />
  );
};

const ForeGroundColor = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'qrCodeToolbar' });

  const { foreGroundColor, updateWidget } = useWidget<QRCodeWidgetData>();

  const onUpdateBackgroundColor = (color: string) => updateWidget({ foreGroundColor: color });

  return (
    <ColorPicker
      color={foreGroundColor}
      label={t('foregroundColor')}
      onChange={onUpdateBackgroundColor}
      showNoColorOption={false}
      showNoColorChecker
    />
  );
};

const URL = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'qrCodeToolbar' });

  const { url, updateWidget } = useWidget<QRCodeWidgetData>();

  const onClick = () => {
    const newUrl = window.prompt('URL', url);
    if (newUrl === null) return;
    if (newUrl === '') return;
    if (url.length > MAX_URL_LENGTH) return;

    updateWidget({ url: newUrl });
  };

  const label = t('url');

  return (
    <Button onClick={onClick} size='sm' aria-label={label} variant='outline'>
      {label}
    </Button>
  );
};
